export const _911INFORM = '911inform';
export const _911_INFORM = '911_inform';
export const AIR_AMBULANCE = 'air_ambulance';
export const CRG = 'CRG';
export const AVIVE = 'avive';
export const GEOCOMM = 'geocomm';
export const SECURE911 = 'secure911';
export const CONNECTED_SITES = 'CONNECTED_SITES';
